import { Auth, onAuthStateChanged, User } from 'firebase/auth';
import { useEffect } from 'react';
import useLoadingValue, { LoadingHook } from './use-loading';

export type AuthStateHook = LoadingHook<User | null, Error>;

type AuthStateOptions = {
    onUserChanged?: (user: User | null) => Promise<void>;
};

export default function useAuthState(auth: Auth, options?: AuthStateOptions): AuthStateHook {
    const { error, loading, setError, setValue, value } = useLoadingValue<User | null, Error>(() => auth.currentUser);

    useEffect(() => {
        const listener = onAuthStateChanged(
            auth,
            async (user) => {
                if (options?.onUserChanged) {
                    try {
                        await options.onUserChanged(user);
                    } catch (e) {
                        setError(e as Error);
                    }
                }
                setValue(user);
            },
            setError,
        );

        return () => {
            listener();
        };
    }, [auth]);

    return [value, loading, error];
}
